/* import __COLOCATED_TEMPLATE__ from './hitl-card.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import type { HitlCardState } from 'embercom/objects/inbox/conversation';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    hitlCardState?: HitlCardState;
  };
}

export default class HitlCard extends Component<Signature> {
  @tracked attributeValues: string[] = [];

  get canSubmit(): boolean {
    return (
      this.args.hitlCardState?.hitlAttributesToCollect.every(
        (_, index) => !!this.attributeValues[index],
      ) ?? false
    );
  }

  @action updateAttributeValue(index: number, value: string) {
    let newValues = [...this.attributeValues];
    newValues[index] = value;
    this.attributeValues = newValues;
  }

  @action stopPropagation(event: Event) {
    event.stopPropagation();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Composer::HitlCard': typeof HitlCard;
    'inbox2/composer/hitl-card': typeof HitlCard;
  }
}
